<div
  class="page-wrapper bg-primary d-flex flex-column align-items-center gap-4 py-4 h-100"
  [breakpoints]="breakpoints"
  (breakpointsStates)="getBreakpointsStates($event)"
>
  <div class="d-flex align-items-center justify-content-center">
    <h1 class="m-0 fw-bold text-white font-30">{{ title() | translate }}</h1>
  </div>

  @if (requestStatus() !== undefined) {
    <div class="w-100 h-100" id="services">
      @if (isNormalScreen) {
        @for (eachSortedServices of sortedServices; track $index) {
          <div class="row justify-content-center" [class.my-4]="$index === 1">
            @for (eachSortedService of eachSortedServices; track $index) {
              @if (!isServiceHidden(eachSortedService, requestStatus()!)) {
                <div class="col-3">
                  <app-service-card [service]="eachSortedService" [requestStatus]="requestStatus()!" titleClass="fw-bold" />
                </div>
              }
            }
          </div>
        }
      } @else {
        <div class="services d-grid">
          @for (service of services; track $index) {
            @if (!isServiceHidden(service, requestStatus()!)) {
              <app-service-card [service]="service" [requestStatus]="requestStatus()!" titleClass="fw-bold" />
            }
          }
        </div>
      }
    </div>
  }
</div>
